module.exports = "../study/imgs/maps/Kanagawa/S8/Ecosystem/Avietchii/Kanagawa_Avietchii_HadGEM2_RCP45_Now.png";